import { createSlice } from '@reduxjs/toolkit'

export const globalLauncherSlice = createSlice({
  name: 'globalLauncher',
  initialState: false,
  reducers: {
    openGlobalLauncher: () => true,
    closeGlobalLauncher: () => false,
  },
  selectors: {
    selectGlobalLauncherIsOpen: (state) => state,
  },
})

export const { openGlobalLauncher, closeGlobalLauncher } = globalLauncherSlice.actions
export const { selectGlobalLauncherIsOpen } = globalLauncherSlice.selectors
export default globalLauncherSlice.reducer
